import { methods } from 'vue-popperjs'
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('auth', { user: 'getUser' }),

		$mx_userIsAdmin() {
			return this.user?.user_group === 'admin'
		},

		$mx_userIsCollaborator() {
			return this.user?.user_group === 'collaborator'
		},

		$mx_userIsSupervisor() {
			return this.user?.user_group === 'supervisor'
		},

		$mx_userIsManager() {
			return this.user?.user_group === 'manager'
		},

		$mx_userIsBroker() {
			return this.user?.user_group === 'broker'
		},

		$mx_userIsAdminOrCollaborator() {
			return this.$mx_userIsAdmin || this.$mx_userIsCollaborator
		},

		$mx_userIsManagerOrBroker() {
			return this.$mx_userIsManager || this.$mx_userIsBroker
		},

		$mx_userIsManagerOrBrokerOrSupervisor() {
			return this.$mx_userIsManager || this.$mx_userIsBroker || this.$mx_userIsSupervisor
		},

		$mx_userHasAdminPermissions() {
			return !this.$mx_userIsBroker && !this.$mx_userIsManager && !this.$mx_userIsSupervisor
		}
	},
	methods: {
		$mx_userGroupHasPermission(permissions, groups, permissionDisabled, user) {
			if (this.$mx_userIsAdmin) return true
			if (permissionDisabled == 0 ) return true
			if (permissionDisabled == 1 && permissions.length == 0) return false
			//if(Boolean(!parseInt(permissionDisabled)) && !permissions.length) return false
			let userGroup = groups.find(group => group.group_name == user.user_group)

			return permissions.some(p => p?.toString() === userGroup?.group_id?.toString());
		}
	  }
	  
}
